module.exports = __webpack_public_path__ + "img/slider-4.fe04bc04.jpg";